<template>
  <div id="Right2">
<!--    <div class="bg-color-black">-->
      <div class="d-flex pt-2 pl-2">
        <router-link to='/science'>
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">服务产品分类</span>
        </span>
        </router-link>
      </div>
      <div class="d-flex jc-center body-box" style=" margin-top: 0;width: 100%;height: 90%;">
        <div  ref="chart" id="myChart" style="width: 100%;height:100%;margin-top: 0.2rem"></div>
      </div>
    </div>
<!--  </div>-->
</template>

<script>
let myChart
import sciApi from '@/api/index.js'
export default {
  data() {
    return {
      tag:'',
      option:{},
      dialogVisible: false,
      videoUrl:'',
      property:[],
      Num:{
        '知识产权':0,
        '法律服务':0,
        '政策申报':0,
        '工商财税':0,
        '科技金融':0,
        '检验检测':0,
        '科技咨询':0,
        '设备共享':0,
        '技研中心':0,
      }
      }
    },
   watch:{
     setregion:{
       immediate: true,
       deep: true,
       handler(val) {
         this.tag = val
       }
     },
     tag:{
       immediate: false,
       deep: true,
       handler(val) {
         console.log(val,'val')
         this.init().then(()=>{
           let num= Object.values(this.Num)
           this.option.series[0].data=num
           myChart.setOption(JSON.parse(JSON.stringify(this.option)),true);
         })
       }
     }
   },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num= Object.values(this.Num)
      this.option.series[0].data=num
      myChart.setOption(JSON.parse(JSON.stringify(this.option)),true);
    })
    this.option = {
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'item',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'shadow'
        },
        // formatter: '{a0}, {a1}',

      },
      grid: {
        // 距离 上右下左 的距离
        left: '3%',
        right: '4%',
        bottom: '1%',
        top:'15%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      yAxis: {
        // 使用类目，必须有data属性
        type: 'value',
        boundaryGap: false,
        // 使用 data 中的数据设为刻度文字
        name: "单位（个）",
        nameTextStyle: {
          nameLocation: "start",
        },
        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          },

        },
        //文字
        axisLabel: {
          color: '#4c9bfd',
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        }
      },
      xAxis: {

        // 使用数据的值设为刻度文字
        type: 'category',
        data:[ '知识产权',
          '法律服务',
          '政策申报',
          '工商财税',
          '科技金融',
          '检验检测',
          '科技咨询',
          '设备共享',
          '技研中心',],
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          show:true,
          lineStyle:{
            color:'#4c9bfd'
          }},
        //文字
        axisLabel: {
          color: '#4c9bfd',
          interval: 0,
          rotate: 30
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#4c9bfd',
            show:true
          }
        },
      },
      series: [{
        type:'bar',
        itemStyle: {
          normal: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              // { offset: 0, color: "#956FD4" },
              // { offset: 1, color: "#3EACE5" }
              { offset: 0, color: '#00fffb' }, // 1 结束颜色
              { offset: 1, color: '#0061ce' }  // 0 起始颜色
            ])
          }
        },
        label: {
          show: true,
          position: 'top',
          color:'#fff',
          formatter: "{c}"
        },
        data: []
      },
      ]
    }
    this.drawLine();
  },
  methods: {
    async init(){
      const that = this;
      // await sciApi.selectMall({})
      await sciApi.selectMall({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.property = data.list || []
        if(this.tag!==''){
          this.property.forEach((item) => {
            if(item.mapAreaDisplay == that.tag)
            {
              that.Num[item.level1Display] += parseInt(item.mapNum);
            }else {
              that.Num[item.level1Display] = 0;
            }
          })
        }else {
          this.property.forEach((item) => {
            that.Num[item.level1Display] += parseInt(item.mapNum);
          })
        }
      })
    },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
       myChart = this.$echarts.init(document.getElementById('myChart'))
      // myChart = this.$echarts.init(this.$refs.chart)
      myChart.setOption(JSON.parse(JSON.stringify(this.option)));
      window.test = myChart
    },
    setOption(){
     // // if(!myChart.clear) return
     // //  myChart.clear()
     //  var setdata={
     //    城口县:[200, 1300, 700, 560, 400],开州区:[20, 130, 70, 56, 40],梁平区:[100,200,300,400,500]}
     //  for(let key in setdata){
     //    if(this.tag == key){
     //      this.option.series[0].data = setdata[key];
     //      console.log(this.option.series)
     //      myChart.setOption(JSON.parse(JSON.stringify(this.option)),true);
     //    }
     //  }
      // option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
#Right2 {
  padding: 0.2rem;
  height:100%;
  width: 100%;
  //height: 5rem;
  //min-width: 3.75rem;
  //border-radius: 0.0625rem;
  .bg-color-black {
    //padding: 0.0625rem;
    //height: 5rem;
    //border-radius: 0.125rem;
  }
  .text {
    color: #ffffff;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
}
</style>